export default __webpack_public_path__ + "a1bc3b9bf79bcda19211d8c1a25dddc8.png";